module.exports = __webpack_public_path__ + "static/media/room-5.a5c06e0b.jpeg";